import { useSelector } from 'react-redux';
import RootState from 'store/state';

export default function useDirectory() {
    const callLog = useSelector<RootState, RootState['callLog']>(
        ({ callLog }) => callLog
    );

    return callLog;
}
